import ElementTypeLabel from "../../ElementTypeLabel";
import AddPlayer from "../AddPlayer";
import ElementCardButton from "../ElementCardButton";
import { ElementPlaceholderCardProps } from "./types";

const ElementPlaceholderCard = ({
  elementType,
  onPress,
}: ElementPlaceholderCardProps) => (
  <ElementCardButton onPress={onPress}>
    <AddPlayer />
    <ElementTypeLabel elementType={elementType} />
  </ElementCardButton>
);

export default ElementPlaceholderCard;
